var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitsTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#2276E3",
    fillRule: "nonzero",
    opacity: 0.152
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.656 2.727l11.461 2.022-2.022 11.459-11.459-2.022z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2276E3",
    fillRule: "nonzero",
    d: "M15.725 5.603a.605.605 0 00-.858-.011l-6.956 6.802L6.376 10.2a.604.604 0 00-1.066.076.603.603 0 00.073.618l1.945 2.778a.615.615 0 00.92.086l7.467-7.299a.606.606 0 00.01-.857z"
  }))));
}
export default SvgBenefitsTick;